module.exports = __webpack_public_path__ + "img/plata2.927cbeae.png";